import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, MessageCircle } from "lucide-react";
import Newsletter from "@/components/Newsletter";
import ServiceStrip from "@/components/ServiceStrip";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#EFE9E1] text-[#111111] border-t border-black/10">
      <ServiceStrip />
      <Newsletter />
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <p className="font-serif-brand text-3xl tracking-[0.18em]">
            RESERVE <span className="text-[#BA8D53]">30</span>
          </p>
          <p className="mt-4 text-sm text-black/60 max-w-sm leading-relaxed">
            Luxury fragrances crafted to leave a lasting impression. Matured 8–10 weeks. Bottled in India, composed for the world.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="overline-label mb-5">Policies</p>
          <ul className="space-y-3 text-sm text-black/60">
            <li><Link data-testid="footer-shipping-link" className="link-line" to="/policies/shipping">Shipping Policy</Link></li>
            <li><Link data-testid="footer-return-link" className="link-line" to="/policies/returns">Return Policy</Link></li>
            <li><Link data-testid="footer-privacy-link" className="link-line" to="/policies/privacy">Privacy Policy</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="overline-label mb-5">House</p>
          <ul className="space-y-3 text-sm text-black/60">
            <li><Link className="link-line" to="/collections">Collections</Link></li>
            <li><Link className="link-line" to="/about">About Us</Link></li>
            <li><Link className="link-line" to="/experience">Experience</Link></li>
            <li><Link className="link-line" to="/word-of-mouth">Word of Mouth</Link></li>
            <li><Link data-testid="footer-contact-link" className="link-line" to="/contact">Contact</Link></li>
            <li><Link data-testid="footer-track-order-link" className="link-line" to="/track-order">Track Order</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="overline-label mb-5">Follow</p>
          <div className="space-y-3">
            <a
              data-testid="footer-instagram-link"
              href="https://instagram.com/reserve30parfums"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm text-black/60 link-line w-fit"
            >
              <Instagram size={16} strokeWidth={1.5} /> Instagram
            </a>
            <a
              data-testid="footer-facebook-link"
              href="https://facebook.com/reserve30parfums"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm text-black/60 link-line w-fit"
            >
              <Facebook size={16} strokeWidth={1.5} /> Facebook
            </a>
            <a
              data-testid="footer-whatsapp-link"
              href="https://wa.me/919975585549"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm text-black/60 link-line w-fit"
            >
              <MessageCircle size={16} strokeWidth={1.5} /> WhatsApp
            </a>
            <a
              data-testid="footer-email-link"
              href="mailto:contact@reserve30.in"
              className="flex items-center gap-2 text-sm text-black/60 link-line w-fit"
            >
              <Mail size={16} strokeWidth={1.5} /> contact@reserve30.in
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-black/10">
        <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-6 flex flex-col md:flex-row justify-between gap-2 text-xs text-black/40 tracking-wider">
          <span>© {new Date().getFullYear()} Reserve 30 Parfums. All rights reserved.</span>
          <span>reserve30.in</span>
        </div>
      </div>
    </footer>
  );
}
